import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusCorFormatter'
})
export class StatusCorFormatterPipe implements PipeTransform {

  transform(status: string, tipo: 'nome' | 'cor' = 'nome'): string {
    if (!status) return tipo === 'nome' ? 'Sem Status' : 'bg-secondary-subtle';
    
    const [nome, cor] = status.split('|');
    return tipo === 'nome' ? nome : cor || 'bg-secondary-subtle';
  }

}
